export class RoleFormDto {
  nameEn: string;
  nameKz: string;
  nameRu: string;
  descriptionEn: string;
  descriptionKz: string;
  descriptionRu: string;
  operations: Array<number>;
}
